/**
 * Taxes and extras as admin set them (GET /settings/charges), applied the
 * same way the server does so a preview matches the bill to the rupee.
 */
import api from '../api/endpoints';

let cache = null;
let inflight = null;

export const loadCharges = async () => {
  if (cache) return cache;
  if (!inflight) {
    inflight = api.settings.charges()
      .then((r) => { cache = r.data || {}; return cache; })
      .catch(() => ({}))
      .finally(() => { inflight = null; });
  }
  return inflight;
};

const clamp = (v) => Math.min(Math.max(Number(v) || 0, 0), 100);

export const taxPercentFor = (rule, unitPrice) => {
  if (!rule || rule.taxMode === 'none') return 0;
  if (rule.taxMode === 'flat') return clamp(rule.taxPercent);
  const slabs = (rule.slabs || []).map((s) => ({ upTo: Number(s.upTo) || 0, percent: clamp(s.percent) }));
  for (let i = 0; i < slabs.length; i += 1) {
    const s = slabs[i];
    if (!s.upTo || unitPrice < s.upTo || i === slabs.length - 1) return s.percent;
  }
  return 0;
};

/** What goes on top of `base` (after discount); `unitPrice` picks a slab. */
export const applyCharges = (rule, base, unitPrice) => {
  const amount = Math.max(0, Number(base) || 0);
  const taxPercent = taxPercentFor(rule, unitPrice !== undefined ? unitPrice : amount);
  const taxes = Math.round((amount * taxPercent) / 100);
  const extras = ((rule && rule.extras) || [])
    .filter((e) => e && e.enabled !== false && e.label)
    .map((e) => ({
      label: e.label,
      amount: e.kind === 'percent' ? Math.round((amount * clamp(e.amount)) / 100) : Math.round(Number(e.amount) || 0),
    }))
    .filter((e) => e.amount > 0);
  const extrasTotal = extras.reduce((n, e) => n + e.amount, 0);
  return {
    taxLabel: (rule && rule.taxLabel) || 'Tax', taxPercent, taxes, extras, extrasTotal, total: amount + taxes + extrasTotal,
  };
};
